var loadRemoteResource = require('../reader/load-remote-resource');

function fetchFrom(callback) {
  return callback || loadRemoteResource;
}

module.exports = fetchFrom;



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/lib/options/fetch.js
// module id = 2309
// module chunks = 0